import { DEFAULT_CURRENCY, moneyFormat } from "@redotech/money/util";
import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  priceConditionFromModel,
  validatePriceCondition,
  type TotalPreDiscountPriceState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const TOTAL_PRE_DISCOUNT_PRICE = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<TotalPreDiscountPriceState>
  >,
): ConditionType<
  TotalPreDiscountPriceState,
  Condition.TotalPreDiscountPrice
> => ({
  name: "Total pre-discount price",
  description(state) {
    if (!state.priceOption) {
      return "The sum of the original prices before discounts for every item the customer is returning, this is the price listed on your website";
    }
    return `The sum of the original prices before discounts for every item the customer is returning is ${state.priceOption.toLowerCase()} ${moneyFormat(
      { amount: +state.amount, currency: DEFAULT_CURRENCY },
    )}`;
  },
  Details(props: ConditionTypeDetailsProps<TotalPreDiscountPriceState>) {
    return React.createElement(Details, props);
  },
  empty: { amount: (0).toFixed(2), priceOption: null },
  fromModel(model) {
    return priceConditionFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.TOTAL_PRE_DISCOUNT_PRICE,
      amount: +state.amount,
      priceOption: state.priceOption,
    };
  },
  valid(state) {
    return validatePriceCondition(state).valid;
  },
});

export { type TotalPreDiscountPriceState } from "@redotech/redo-model/return-flow/condition-validate";
